export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7422.c0104d6c.jpg";